import React, { useState, useCallback} from 'react';
import {Knob, Arc, Pointer} from 'rc-knob';
import {connect} from 'react-redux';
import {setMixColorValue} from 'actions/index.js';
import {changeColor} from 'engine/mix/actions.js';
import Colors from 'components/Colors.js';

const colors = new Colors();

function ColorKnob({value=0.5, setColorValue, mixEffects, sequencerEngine, id}) {
    const onChange = useCallback((v) => {
        sequencerEngine.multiSequencerEngine.dispatch(
            changeColor(
                id,
                v));
    }, []);

    let color = colors.getColorForHash(id || 'what');
    return (
        <div className="color-container">
            <Knob 
              size={50}  
              angleOffset={220} 
              angleRange={280}
              value={value}
              min={0}
              max={1}
              onChange={value => onChange(value)}
              >
              <Arc 
                arcWidth={3}
                color={color}
                background="rgb(56, 63, 72)"
                />
              <Pointer 
                width={3} 
                height={15}
                radius={10}
                type="rect"
                color={color}
                />
            </Knob>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        value: state.explore.mixColorValues[props.id] 
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setColorValue: (value) => dispatch(setMixColorValue(props.id, value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorKnob);
